var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorumLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 36,
    viewBox: "0 0 126 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_7713)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4788 12.8063H40.2578V9.72307H54.4761V12.8063H49.2552V26.077H45.4788V12.8063ZM72.6377 17.8992C72.6377 22.6209 68.9647 26.077 64.0073 26.077C59.0499 26.077 55.3769 22.5975 55.3769 17.8992C55.3769 13.2008 59.0282 9.7214 64.0073 9.7214C68.9864 9.7214 72.6377 13.1774 72.6377 17.8992ZM68.9414 17.8992C68.9414 14.8946 66.8229 12.8397 64.0056 12.8397C61.1883 12.8397 59.0699 14.8946 59.0699 17.8992C59.0699 20.9038 61.1883 22.9587 64.0056 22.9587C66.8229 22.9587 68.9414 20.9038 68.9414 17.8992ZM89.3348 26.077H85.2781L82.1305 21.5208H78.6577V26.077H74.8812V9.71973H81.9454C86.3039 9.71973 89.0328 11.987 89.0328 15.6554C89.0328 18.1082 87.7968 19.9089 85.6768 20.8202L89.3364 26.0787L89.3348 26.077ZM85.208 15.6554C85.208 13.8563 84.0421 12.8046 81.7352 12.8046H78.6577V18.5061H81.7352C84.0437 18.5061 85.208 17.431 85.208 15.6554ZM98.3939 26.077C102.954 26.077 105.658 24.1943 105.658 19.4625V9.72307H101.992V18.9977C101.992 22.0525 100.686 22.9069 98.4172 22.9069C96.1487 22.9069 94.8426 22.0525 94.8426 18.9977V9.72307H91.1312V19.4625C91.1312 24.1943 93.8351 26.077 98.3955 26.077H98.3939ZM126.442 26.077L126.395 9.72307H123.296L117.283 19.8855L111.176 9.72307H108.053V26.077H111.596V16.4746L116.374 24.3481H118.075L122.876 16.264L122.899 26.077H126.442Z",
    fill: "url(\"#paint0_linear_1083_7713\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3991 6.30793L20.2049 0.987602C17.933 -0.326596 15.1358 -0.326596 12.8639 0.987602L3.66968 6.30793C1.39948 7.62213 0 10.0516 0 12.68V23.3206C0 25.949 1.39948 28.3784 3.67135 29.6926L12.8656 35.013C15.1374 36.3272 17.9347 36.3272 20.2066 35.013L29.4008 29.6926C31.6727 28.3784 33.0721 25.949 33.0721 23.3206V12.68C33.0721 10.0516 31.6727 7.62213 29.4008 6.30793H29.3991Z",
    fill: "url(\"#paint1_linear_1083_7713\")"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0683 12.6806V22.7629C33.0683 23.1842 32.7264 23.527 32.3061 23.527C31.8857 23.527 31.5438 23.1842 31.5438 22.7629V12.6806C31.5438 10.604 30.4278 8.66783 28.6347 7.63118L19.4405 2.31086C18.5581 1.79922 17.5523 1.53003 16.5314 1.53003C15.5106 1.53003 14.5064 1.80089 13.6224 2.31086L5.5541 6.98077C5.54409 6.98746 5.53242 6.99415 5.52241 6.99917C5.41399 7.05769 5.29055 7.09113 5.15878 7.09113C4.73843 7.09113 4.39648 6.74836 4.39648 6.32702C4.39648 6.05448 4.53994 5.81538 4.75344 5.67995C4.77012 5.66992 4.7868 5.65989 4.80348 5.65153L12.8634 0.986625C15.1353 -0.327573 17.9343 -0.327573 20.2045 0.986625L29.3987 6.30695C31.6705 7.62115 33.07 10.0506 33.07 12.6806H33.0683Z",
    fill: "#FF7DB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6792 6.90885C29.6792 7.33019 29.3372 7.67295 28.9169 7.67295C28.7851 7.67295 28.6617 7.63951 28.5549 7.58099C28.5432 7.57598 28.5332 7.56929 28.5232 7.5626L19.6242 2.41282C19.6126 2.4078 19.6026 2.40111 19.5926 2.39443C19.3724 2.26066 19.2256 2.01655 19.2256 1.74067C19.2256 1.31932 19.5675 0.976562 19.9879 0.976562C20.1197 0.976562 20.2431 1.01 20.3515 1.06852C20.3615 1.07354 20.3732 1.08023 20.3832 1.08691L29.2705 6.23168L29.3239 6.26178C29.539 6.39721 29.6808 6.63631 29.6808 6.90885H29.6792Z",
    fill: "#FFD6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4527 34.0322V34.0405C13.4477 34.6157 12.8305 34.9785 12.3251 34.701L12.3068 34.6909L12.2184 34.6391L3.67135 29.6916C1.39948 28.3791 0 25.9497 0 23.3213V15.2104C0 14.9997 0.0850698 14.8091 0.223517 14.6703C0.371972 14.5215 0.582144 14.4329 0.814001 14.4479C1.21767 14.4747 1.52458 14.8292 1.52458 15.2371V23.3213C1.52458 25.3979 2.63883 27.3324 4.43364 28.3708L13.0724 33.3701C13.1908 33.4386 13.2859 33.5356 13.351 33.6493C13.416 33.763 13.4527 33.8951 13.4527 34.0305V34.0322Z",
    fill: "#811585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.453 34.0323C13.453 34.6125 12.8325 34.9803 12.3254 34.7028L12.3071 34.6928L6.35555 31.2484C5.99025 31.0378 5.86682 30.5696 6.07699 30.2051C6.28716 29.8389 6.75421 29.7152 7.11784 29.9259L13.0711 33.3719C13.1895 33.4404 13.2846 33.5374 13.3496 33.6511C13.4147 33.7648 13.4514 33.8969 13.4514 34.0323H13.453Z",
    fill: "#5B115C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3351 17.7713C27.3351 19.9399 24.9931 21.2942 23.1199 20.2091L19.6171 18.1809V34.0383C19.6221 34.6134 20.2392 34.9762 20.7447 34.6987L20.2059 35.0114C17.934 36.3256 15.1367 36.3256 12.8649 35.0114L12.3094 34.6887L12.3277 34.6987C12.8315 34.9762 13.4487 34.6118 13.4553 34.0383V18.1642L9.92411 20.2091C9.47207 20.4716 8.99001 20.5903 8.52296 20.5903C7.05509 20.5903 5.70898 19.4132 5.70898 17.7696C5.70898 16.3852 6.44626 15.1061 7.64224 14.4122C7.64224 14.4122 13.07 11.2722 15.4386 9.90616C16.1092 9.51826 16.9332 9.51826 17.6054 9.90616C19.974 11.2739 25.4018 14.4122 25.4018 14.4122C26.0006 14.76 26.4827 15.2516 26.8163 15.8318C27.1499 16.4119 27.3334 17.0774 27.3334 17.7696L27.3351 17.7713Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.162 13.0925C26.162 13.0925 20.7325 9.95246 18.3639 8.58476C17.8034 8.26206 17.1662 8.08984 16.519 8.08984C15.8718 8.08984 15.2347 8.26039 14.6742 8.58476C14.4807 8.69678 14.2672 8.81884 14.0387 8.9526C13.6734 9.16327 13.5483 9.63143 13.7584 9.99593C13.9686 10.3621 14.4357 10.4858 14.7993 10.2752C15.0278 10.1431 15.2413 10.0193 15.4332 9.90899C16.1037 9.52108 16.9294 9.52108 17.5999 9.90899C19.9685 11.2767 25.3963 14.415 25.3963 14.415C26.5923 15.1073 27.3296 16.388 27.3296 17.7724C27.3296 18.2256 27.2262 18.6436 27.0477 19.0114C26.9343 19.2455 26.9343 19.518 27.0644 19.7437C27.3663 20.2671 28.1352 20.2537 28.4038 19.712C28.699 19.1201 28.8542 18.4596 28.8542 17.7724C28.8542 15.848 27.8217 14.0539 26.1586 13.0908L26.162 13.0925Z",
    fill: "#FF7DB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5951 11.0293C21.7094 10.5176 20.777 9.97924 19.9446 9.49771C19.5793 9.28703 19.1139 9.41243 18.9038 9.7786C18.6936 10.1448 18.8187 10.6113 19.1823 10.8219C20.0147 11.3035 20.9488 11.8419 21.8328 12.3535C22.1981 12.5642 22.6635 12.4388 22.8737 12.0743C23.0839 11.7081 22.9588 11.2416 22.5951 11.0309V11.0293Z",
    fill: "#FFD6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1083_7713",
    x1: 40.2578,
    y1: 17.8992,
    x2: 126.442,
    y2: 17.8992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF761C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1083_7713",
    x1: 6.87731,
    y1: 31.6773,
    x2: 26.0135,
    y2: 4.70727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_7713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 36,
    fill: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1083_7713",
    x1: 40.2578,
    y1: 17.8992,
    x2: 126.442,
    y2: 17.8992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF761C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1083_7713",
    x1: 6.87731,
    y1: 31.6773,
    x2: 26.0135,
    y2: 4.70727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B400FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorumLogoWithText);
export default __webpack_public_path__ + "static/media/TorumLogoWithText.47f85e2173c06fb08c4adf777b04a5b8.svg";
export { ForwardRef as ReactComponent };